/**
 * CMCD_UPLOADの使い方ページ内容
 */

import { Step } from "../components/Step";
import { DownloadInstructions } from "../components/DownloadInstructions";
import cmcdUploadScreen from "./img/cmcd_upload.png";
import saveData from "./img/save_data1.png";

/**
 *
 * @returns CMCD_UPLOADの使い方のJSX Element
 */
export const HowToUse: React.FC = () => {
  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">ロギングデータをパソコンで確認する</h2>
        <DownloadInstructions
          downloadLink="/cmcd-200/HowToDownload"
          driverLink="/cmcd-200/HowToInstallDeviceDriver"
        />
        <Step
          step="1"
          text="ロギング測定終了後、CMCD-200の電源が入っている状態で、本器をお客様のお持ちのパソコンとUSBケーブル(別売)で接続してください。（接続後にCMCD-200の電源を入れても大丈夫です。）本器にUSBケーブルを接続する場合は接続方向に注意してください。"
        />

        <Step
          step="2"
          text="パソコンにダウンロードした「CMCD-200_Software」フォルダ内にあるアップロードソフトウェアフォルダ内の「CMCD_UPLOAD.exe」をダブルクリックして起動してください。"
        />

        <Step
          step="3"
          text="「データ取り込み」をクリックすると、ロギングデータ(CSV形式)の保存画面が表示されるので、保存先を設定後「保存」をクリックしてください。"
          image={cmcdUploadScreen}
          alt="CMCD_UPLOADの画面"
        />

        <Step
          step="4"
          text="保存したロギングデータ(CSV形式)をダブルクリックして開いてください。
          ロギングした形式(瞬時濃度もしくは平均値)、日時、一酸化炭素・二酸化炭素の濃度が表示されます。"
          image={saveData}
          alt="Excelで保存したcsvファイルを開いた画面"
        />

        <Step
          step="5"
          text="Excelをお使いの場合、保存する際は、Officeボタンをクリックし「名前をつけて保存」をクリックし、ファイルの種類をExcelブックに変更してから保存してください。"
        />
      </section>
    </div>
  );
};
